import React from "react";
import {Box, Card, CardContent, Stack, Typography} from "@mui/material";

type Props = {
    title: React.ReactNode
    subtitle?: React.ReactNode
    /** Show the subtitle next to the title instead of below it */
    inlineSubtitle?: boolean
    /** Shown on the right of the header */
    actions?: React.ReactNode
    className?: string
    /** Let the content take the remaining height of the card (when cards in a row are stretched) */
    fill?: boolean
    children: React.ReactNode
}

/**
 * Card around a chart or table section of the Spend Landscape page.
 */
export const ChartCard: React.FC<Props> = ({title, subtitle, inlineSubtitle, actions, className, fill, children}) =>
    <Card variant="outlined" className={'spend-landscape-card' + (fill ? ' fill' : '') + (className ? ` ${className}` : '')}>
        <CardContent>
            <Stack direction="row" alignItems="flex-start" gap={1} className="spend-landscape-card-header">
                <Box sx={{minWidth: 0}}>
                    <Stack direction={inlineSubtitle ? 'row' : 'column'} alignItems={inlineSubtitle ? 'baseline' : 'flex-start'}
                           columnGap={1.5}>
                        <Typography variant="subtitle1" component="h2" fontWeight={600}>{title}</Typography>
                        {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
                    </Stack>
                </Box>
                <Box sx={{flexGrow: 1}}/>
                {actions}
            </Stack>
            {children}
        </CardContent>
    </Card>;
